import { useMemo, useState } from "react";
import Reveal from "@/components/base/Reveal";
import { filterOptions, versionEntries } from "@/mocks/home";

export default function VersionFilter() {
  const [activeTag, setActiveTag] = useState("全部");

  const filtered = useMemo(() => {
    if (activeTag === "全部") return versionEntries;
    return versionEntries.filter((entry) => entry.tags.includes(activeTag));
  }, [activeTag]);

  return (
    <section id="filter" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <Reveal>
          <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
            <div className="max-w-2xl">
              <p className="font-label text-xs font-semibold uppercase tracking-[0.25em] text-primary-600">
                Quick Filter
              </p>
              <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                按标签速查版本条目
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
                下方条目均为本页已有内容的整理。选择标签即可在当前页面内筛选，结果会即时更新。
              </p>
            </div>
            <p className="font-label text-xs text-secondary-600">当前显示 {filtered.length} 条</p>
          </div>
        </Reveal>

        <Reveal delay={60}>
          <div
            role="group"
            aria-label="按标签筛选版本条目"
            className="mt-8 flex flex-wrap gap-2"
          >
            {filterOptions.map((option) => (
              <button
                key={option}
                type="button"
                aria-pressed={activeTag === option}
                onClick={() => setActiveTag(option)}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                  activeTag === option
                    ? "bg-primary-500 text-background-50"
                    : "border border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
                }`}
              >
                {option}
              </button>
            ))}
          </div>
        </Reveal>

        <div className="mt-8 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {filtered.map((entry) => (
            <article
              key={entry.id}
              className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <div className="flex flex-wrap gap-1.5">
                {entry.tags.map((tag) => (
                  <span
                    key={tag}
                    className="rounded-full bg-secondary-100 px-2.5 py-1 font-label text-xs text-secondary-900"
                  >
                    {tag}
                  </span>
                ))}
              </div>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{entry.title}</h3>
              <p className="mt-1 font-label text-xs text-accent-700">{entry.format}</p>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{entry.desc}</p>
              <p className="mt-4 flex items-start gap-2 border-t border-background-200 pt-4 text-xs text-foreground-700">
                <i className="ri-user-heart-line mt-0.5 text-primary-500" aria-hidden="true"></i>
                <span>{entry.suitable}</span>
              </p>
            </article>
          ))}
        </div>

        {filtered.length === 0 && (
          <p className="mt-8 rounded-lg border border-background-300 bg-background-50 px-6 py-10 text-center text-sm text-foreground-600">
            当前标签下暂无条目，试试选择其他标签。
          </p>
        )}
      </div>
    </section>
  );
}